/**
 * Kebab row menu — README "Row menu": Copy domain / Pause|Resume embedding /
 * Remove website. Paused rows carry an explanatory footnote about their
 * current state; DropdownMenu's `footer` slot always renders last (after
 * every item, one top rule).
 */
import React, { useMemo } from "react";
import DropdownMenu from "../../theme/untitled/DropdownMenu/DropdownMenu";
import IconButton from "../../theme/untitled/IconButton/IconButton";
import Icon from "../../theme/untitled/icons/Icon";
import styles from "./RowMenu.module.scss";

const RowMenu = ({ domain, onCopy, onTogglePause, onRemove, disabled }) => {
  const isPaused = !domain.available;

  const items = useMemo(
    () => [
      {
        key: "copy",
        label: "Copy domain",
        icon: <Icon name="Copy01" />,
        onClick: () => onCopy(domain),
      },
      {
        key: "toggle",
        label: isPaused ? "Resume embedding" : "Pause embedding",
        icon: <Icon name={isPaused ? "Check" : "SlashCircle01"} />,
        onClick: () => onTogglePause(domain),
      },
      { type: "divider" },
      {
        key: "remove",
        label: "Remove website",
        icon: <Icon name="Trash01" />,
        destructive: true,
        onClick: () => onRemove(domain),
      },
    ],
    [domain, isPaused, onCopy, onTogglePause, onRemove]
  );

  const footer = isPaused
    ? "Widgets aren't loading on this domain. Resume to restore them."
    : undefined;

  return (
    <DropdownMenu
      trigger={
        <IconButton icon={<Icon name="DotsVertical" />} label="More actions" disabled={disabled} />
      }
      items={items}
      footer={footer}
      panelClassName={styles.panel}
    />
  );
};

export default RowMenu;
